module.exports = __webpack_public_path__ + "static/media/1POLICY13.7680f14f.jpg";